import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import { NavLink } from "react-router-dom";
import { NavGroup } from "./styles.js";

class MenuItems extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openedCustomers: false,
      openedReports: false,
      openedCompany: false,
      openedAdministrative: false,
      openedComissions: false
    };
  }

  handleOpened = (name, val) => {
    if (this.props.fit) {
      return;
    }
    this.setState({ [name]: !val });
  };

  handlePermissions = permission => {
    return this.props.permissions.data.indexOf(permission) > -1 ||
      this.props.master
      ? true
      : false;
  };

  render() {
    const tenant = localStorage.getItem("@ecorban-app:tenant");

    return (
      <Fragment>
        <NavGroup>
          {this.handlePermissions("VISUALIZAR DASHBOARD") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Dashboard"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/dashboard`}>
                  <i className="fa fa-tachometer" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR CLIENTES") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Clientes"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/clientes`}>
                  <i className="fa fa-users" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR PROPOSTAS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Propostas"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/propostas`}>
                  <i className="fa fa-copy" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          <Divider />
          {((!!this.props.pesquisador_module && !!this.props.pesquisador) ||
            !!this.props.super_user) && (
            <Fragment>
              <li>
                <Tooltip
                  disableFocusListener
                  title="Pesquisador - Dados Cadastrais"
                  placement="right"
                  classes={{ tooltip: "tooltip" }}
                >
                  <NavLink to={`/${tenant}/dados-cadastrais`}>
                    <i className="fa fa-search" />
                  </NavLink>
                </Tooltip>
              </li>
              <li>
                <Tooltip
                  disableFocusListener
                  title="Pesquisador - Consignado INSS"
                  placement="right"
                  classes={{ tooltip: "tooltip" }}
                >
                  <NavLink to={`/${tenant}/consignado-inss`}>
                    <i className="fa fa-search" />
                  </NavLink>
                </Tooltip>
              </li>
            </Fragment>
          )}
          <Divider />
          {this.handlePermissions("GERAR DESEMPENHO") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Desempenho"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/desempenho`}>
                  <i className="fa fa-pie-chart" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("GERAR RANKINGS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Rankings"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/rankings`}>
                  <i className="fa fa-bar-chart" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("GERAR RELATÓRIO DE METAS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Relatório de Metas"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/relatorio-metas`}>
                  <i className="fa fa-bullseye" />
                </NavLink>
              </Tooltip>
            </li>
          )}

          {this.handlePermissions("VISUALIZAR ORGANOGRAMA") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Organograma"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/organograma`}>
                  <i className="fa fa-sitemap" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          <Divider />
          {this.handlePermissions("LISTAR CARGOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Cargos"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/cargos`}>
                  <i className="fa fas fa-briefcase" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("CADASTRAR COMUNICADOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Comunicados"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/comunicados`}>
                  <i className="fa fas fa-envelope" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR FERIADOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Feriados"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/feriados`}>
                  <i className="fa fa-plane" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR GRUPOS DE ACESSOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Grupos de Acessos"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/grupos-de-acessos`}>
                  <i className="fa fa-lock" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR LOJAS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Lojas"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/lojas`}>
                  <i className="fa fa-home" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR REGIÕES") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Regiões"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/regioes`}>
                  <i className="fa fa-globe" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR TIPOS DE USUÁRIO") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Tipos de Usuário"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/tipos-de-usuarios`}>
                  <i className="fa fa-shield" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR USUÁRIOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Usuários"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/usuarios`}>
                  <i className="fa fa-user" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          <Divider />
          {(this.handlePermissions("LISTAR BORDERÔS DE REMESSA") ||
            this.handlePermissions("LISTAR BORDERÔS DE BANCO")) && (
            <li>
              <Tooltip
                disableFocusListener
                title="Borderôs"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/borderos`}>
                  <i className="fa fa-th-list" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR BANCOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Bancos"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/bancos`}>
                  <i className="fa fa-university" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR OPERAÇÕES") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Operações"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/operacoes`}>
                  <i className="fa fa-th-list" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR ORIGEM DA VENDA") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Origem da Venda"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/origem-da-venda`}>
                  <i className="fa fa-arrow-right" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR PROMOTORAS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Promotoras"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/promotoras`}>
                  <i className="fa fa-credit-card" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR PRODUTOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Produtos"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/produtos`}>
                  <i className="fa fa-product-hunt" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR STATUS DE PROPOSTA") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Status de Proposta"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/status-de-proposta`}>
                  <i className="fa fa-check" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR METAS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Metas"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/metas`}>
                  <i className="fa fa-bullseye" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR MATERIAIS DE APOIO") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Materiais de Apoio"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/materiais-de-apoio`}>
                  <i className="fa fa-file" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          <Divider />
          {this.handlePermissions("EXTRATO PAGO") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Extrato Pago"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/extrato-pago`}>
                  <i className="fa fa-list-alt" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("GERAR REPASSES") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Gerar Repasses"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/gerar-repasses`}>
                  <i className="fa fa-exchange" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          {this.handlePermissions("LISTAR TABELAS DE CONVÊNIOS") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Tabelas de Convênios"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/tabelas-de-convenios`}>
                  <i className="fa fa-table" />
                </NavLink>
              </Tooltip>
            </li>
          )}
          <Divider />
          {this.handlePermissions("AJUDA") && (
            <li>
              <Tooltip
                disableFocusListener
                title="Ajuda"
                placement="right"
                classes={{ tooltip: "tooltip" }}
              >
                <NavLink to={`/${tenant}/ajuda`}>
                  <i className="fa fa-question-circle" />
                </NavLink>
              </Tooltip>
            </li>
          )}
        </NavGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  permissions: state.permissions,
  master: state.permissions.master,
  pesquisador_module: state.permissions.pesquisador_module,
  pesquisador: state.permissions.pesquisador,
  super_user: state.permissions.super_user,
  page: state.pages
});

export default connect(mapStateToProps)(MenuItems);



// WEBPACK FOOTER //
// ./src/components/MenuItemsFit/index.js